"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postVehicleSync = void 0;
/**
 * Allows you to trigger updating of Slack channel name, topic and members for all or specific vehicles that are scheduled for a specific date
 */
var postVehicleSync = function (instance) {
    return function (body, config) {
        return instance.post("/vehicles/sync", body, config);
    };
};
exports.postVehicleSync = postVehicleSync;
